import { render, staticRenderFns } from "./HotelChain.vue?vue&type=template&id=02ea4c73&scoped=true"
import script from "./HotelChain.vue?vue&type=script&lang=js"
export * from "./HotelChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ea4c73",
  null
  
)

export default component.exports